// extracted by mini-css-extract-plugin
module.exports = {"scenarioTableRoot":"l1ImteKe"};